export default "__VITE_ASSET__RiQYmn_e__"